module.exports = __webpack_public_path__ + "static/oversize-cargo-0399ab5028469fce3e2ec895d5c2d5bf.jpg";